export interface RadioIEnumValue{
    getEnumValueName():string;
    getEnumValue():any;

    /**
     * 值显示
     */
    value:string;
}

export class RadioEnumValue implements RadioIEnumValue{

    getEnumValueName():string{
        return this.name;
    }

    getEnumValue():any{
        return this.value;
    }
    
    /**
     * 文本显示
     */
    name:string;

    /**
     * 值显示
     */
    value:string;
}